interface RangeRowProps {
  label: string;
  minVal: string;
  maxVal: string;
  minPlaceholder?: string;
  maxPlaceholder?: string;
  unit?: string;
  onChange: (min: string, max: string) => void;
}

export default function RangeRow({
  label,
  minVal,
  maxVal,
  minPlaceholder,
  maxPlaceholder,
  unit,
  onChange,
}: RangeRowProps) {
  return (
    <div>
      <p className="text-xs text-gray-500 mb-1">
        {label}
        {unit ? ` (${unit})` : ''}
      </p>
      <div className="flex items-center gap-1.5">
        <input
          type="number"
          placeholder={minPlaceholder ?? 'Min'}
          value={minVal}
          onChange={e => onChange(e.target.value, maxVal)}
          className="w-full border rounded-lg px-2 py-1.5 text-sm"
        />
        <span className="text-gray-400 text-xs shrink-0">–</span>
        <input
          type="number"
          placeholder={maxPlaceholder ?? 'Max'}
          value={maxVal}
          onChange={e => onChange(minVal, e.target.value)}
          className="w-full border rounded-lg px-2 py-1.5 text-sm"
        />
      </div>
    </div>
  );
}
